import api from './api';

// L&D dashboard KPIs
export const getLdDashboard = (params) =>
  api.get('/v1/training-reports/dashboard-summary', { params });

// Manager team dashboard
export const getMyTeamTraining = (params) =>
  api.get('/v1/training-reports/my-team', { params });

// Individual reports — each returns a PaginatedList
export const getCompletionReport = (params) =>
  api.get('/v1/training-reports/completion', { params });

export const getOverdueReport = (params) =>
  api.get('/v1/training-reports/overdue', { params });

export const getComplianceReport = (params) =>
  api.get('/v1/training-reports/compliance', { params });

export const getQuizStatsReport = (params) =>
  api.get('/v1/training-reports/quiz-stats', { params });

export const getRetryAnalysisReport = (params) =>
  api.get('/v1/training-reports/retry', { params });

export const getFailureAnalysisReport = (params) =>
  api.get('/v1/training-reports/failure', { params });

export const getCertificationReport = (params) =>
  api.get('/v1/training-reports/certifications', { params });

export const getBadgeReport = (params) =>
  api.get('/v1/training-reports/badges', { params });

export const getEvaluationReport = (params) =>
  api.get('/v1/training-reports/evaluation', { params });

export const getVersionHistoryReport = (params) =>
  api.get('/v1/training-reports/version-history', { params });

// Unified export — downloads an XLSX for the given report type.
export const exportTrainingReport = (reportType, params) =>
  api.get(`/v1/training-reports/${reportType}/export`, {
    params,
    responseType: 'blob',
  });
